import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14cf80ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "UnderGraduatePageBackground" }
const _hoisted_2 = { id: "mainBody" }
const _hoisted_3 = { class: "majorInfo" }
const _hoisted_4 = { style: {"font-size":"20px","font-family":"微软雅黑"} }
const _hoisted_5 = { class: "mainContainer" }
const _hoisted_6 = { class: "majorItemContainer" }
const _hoisted_7 = { class: "majorItemTitle" }
const _hoisted_8 = { class: "majorItemMain" }
const _hoisted_9 = {
  key: 1,
  class: "emptyContainer"
}
const _hoisted_10 = { class: "mainContainer" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "selectTitle" }, "院校省份", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "selectTitle" }, "院校特性", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "selectTitle" }, "院校属性", -1))
const _hoisted_14 = {
  key: 1,
  class: "emptyContainer"
}

import {ref, reactive, nextTick, onDeactivated, onActivated} from 'vue'
  import {useRoute, useRouter} from "vue-router";
  import {
    masterGetProvince,
    masterGetUniversityFeatures, masterMasterUndergraduate,
    masterMasterUniversity
  } from "@/network/axios";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MobileUnderGraduatePage',
  setup(__props) {

  let router = useRouter();
  let route = useRoute();

  let majorCode: any = ref('');
  majorCode.value = route.params.masterCode;


  //院校省份 下拉框
  let province = ref('');
  let provinceArray = ref([]);
  masterGetProvince('/master/getProvince').then((res) => {
    if (res.data.code == 200) {
      provinceArray.value = [];
      provinceArray.value = res.data.data;
    }
  });

  //院校特性 下拉框
  let collegeTags = ref('');
  let collegeTagsArray = ref([]);
  masterGetUniversityFeatures('/master/getUniversityFeatures').then((res) => {
    if (res.data.code == 200) {
      collegeTagsArray.value = [];
      collegeTagsArray.value = res.data.data;
    }
  });

  //院校属性 下拉框
  let collegeAttribute = ref('');


  //切换 tabs 栏时触发
  let elTabId = ref('对应本科专业');
  const tabClick = (tab: any, event: any) => {
    if (tab.paneName == '开设院校') {
      elTabId.value = '开设院校';
      getCollegeContainer()
    } else if (tab.paneName == '对应本科专业') {
      elTabId.value = '对应本科专业';
      getUndergraduateMajor()
    }
  };

  //点击 开设院校 获取信息
  let collegeArray = ref([]);

  //majorContainer的滚动条
  let majorContainerScrollBar = ref();
  //collegeContainer 的滚动条
  let collegeContainerScrollBar = ref();
  //切换 开设院校 下拉框获取信息
  let getCollegeContainer = () => {
    masterMasterUniversity('/master/masterUniversity', {
      params: {
        features: collegeTags.value,
        masterCode: majorCode.value,
        property: collegeAttribute.value,
        province: province.value,
      }
    }).then((res) => {
      if (res.data.code == 200) {
        nextTick(() => {
          collegeContainerScrollBar.value.scrollTop = 0;
        });
        collegeArray.value = [];
        collegeArray.value = res.data.data;
      }
    })
  };
  getCollegeContainer();
  //点击 开设院校 里面的学校跳转页面
  let collegeNameClick = (collegeCode: any) => {
    // router.push('/MobileCollegeSituation/' + collegeCode)
    window.open('/MobileCollegeSituation/' + collegeCode,'_blank')
  };

  //点击 对应本科专业 获取信息
  let majorArray = ref([]);
  let title = reactive({
    className: '',
    masterType: '',
    masterCode: '',
  });
  //点击 对应本科专业 获取信息
  let getUndergraduateMajor = () => {
    masterMasterUndergraduate('/master/masterUndergraduate', {
      params: {
        masterCode: majorCode.value,
      }
    }).then((res) => {
      if (res.data.code == 200) {
        title.className = res.data.data.masterMajor.masterName;
        title.masterType = res.data.data.masterMajor.masterType;
        title.masterCode = res.data.data.masterMajor.masterCode;
        majorArray.value = [];
        majorArray.value = res.data.data.undergraduates;
      }
    })
  };
  getUndergraduateMajor();

  //点击 对应本科专业 里面的专业跳转页面
  let majorNameClick = (majorCode: any) => {
    window.open('/MobileMajorSituation/' + majorCode,'_blank')
    // router.push('/MobileMajorSituation/' + majorCode)
  }


  // //离开页面时，记录滚动条，返回页面时 滚动条 再回到之前的位置
  // let backMajorContainerScrollBar = ref();
  // let backCollegeContainerScrollBar = ref();
  // //缓存组件 离开页面前
  // onDeactivated(() => {
  //   backMajorContainerScrollBar.value = majorContainerScrollBar.value.scrollTop;
  //   backCollegeContainerScrollBar.value = collegeContainerScrollBar.value.scrollTop;
  // });
  // //缓存组件 被激活时
  // onActivated(() => {
  //   majorContainerScrollBar.value.scrollTop = backMajorContainerScrollBar.value
  //   collegeContainerScrollBar.value.scrollTop = backCollegeContainerScrollBar.value
  // });

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(title).className), 1),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 13 }, {
              default: _withCtx(() => [
                _createTextVNode("学位类别:" + _toDisplayString(_unref(title).masterType), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 11 }, {
              default: _withCtx(() => [
                _createTextVNode("专业代码:" + _toDisplayString(_unref(title).masterCode), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_tabs, {
        modelValue: _unref(elTabId),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(elTabId) ? (elTabId).value = $event : elTabId = $event)),
        onTabClick: tabClick,
        style: {"padding":"0 15px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "对应本科专业",
            name: "对应本科专业"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "开设院校",
            name: "开设院校"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "majorContainer",
          ref_key: "majorContainerScrollBar",
          ref: majorContainerScrollBar
        }, [
          (_unref(majorArray).length>0)
            ? (_openBlock(), _createBlock(_component_el_row, {
                key: 0,
                class: "majorRow"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(majorArray), (item) => {
                    return (_openBlock(), _createBlock(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_el_link, {
                              onClick: ($event: any) => (_unref(majorNameClick)(item.majorCode)),
                              class: "collegeItemLink"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.majorName), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _createElementVNode("div", _hoisted_8, " 国标代码：" + _toDisplayString(item.majorCode) + " | 专业年限：" + _toDisplayString(item.duration) + " | 授予学位：" + _toDisplayString(item.bacherlor), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 256))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_el_empty, { description: "暂无数据" })
              ]))
        ], 512)
      ], 512), [
        [_vShow, _unref(elTabId) == '对应本科专业']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_row, { style: {"height":"50px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              align: "center",
              span: 8
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createTextVNode("  "),
                _createVNode(_component_el_select, {
                  "popper-class": "elPopperSelect",
                  modelValue: _unref(province),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(province) ? (province).value = $event : province = $event)),
                  placeholder: "所有",
                  style: {"width":"110px"},
                  clearable: "",
                  onChange: _unref(getCollegeContainer)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(provinceArray), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.pid,
                        label: item.primary,
                        value: item.primary
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              align: "center",
              span: 8
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _createTextVNode("   "),
                _createVNode(_component_el_select, {
                  "popper-class": "elPopperSelect",
                  modelValue: _unref(collegeTags),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(collegeTags) ? (collegeTags).value = $event : collegeTags = $event)),
                  placeholder: "所有",
                  style: {"width":"110px"},
                  clearable: "",
                  onChange: _unref(getCollegeContainer)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(collegeTagsArray), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.labelTypeId,
                        label: item.labelName,
                        value: item.labelName
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              align: "center",
              span: 8
            }, {
              default: _withCtx(() => [
                _hoisted_13,
                _createTextVNode("   "),
                _createVNode(_component_el_select, {
                  "popper-class": "elPopperSelect",
                  modelValue: _unref(collegeAttribute),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(collegeAttribute) ? (collegeAttribute).value = $event : collegeAttribute = $event)),
                  placeholder: "所有",
                  style: {"width":"110px"},
                  clearable: "",
                  onChange: _unref(getCollegeContainer)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      key: "公办",
                      label: "公办",
                      value: "公办"
                    }),
                    _createVNode(_component_el_option, {
                      key: "民办",
                      label: "民办",
                      value: "民办"
                    }),
                    _createVNode(_component_el_option, {
                      key: "内地与港澳台地区合作办学",
                      label: "内地与港澳台地区合作办学",
                      value: "内地与港澳台地区合作办学"
                    }),
                    _createVNode(_component_el_option, {
                      key: "中外合作办学",
                      label: "中外合作办学",
                      value: "中外合作办学"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: "collegeContainer",
          ref_key: "collegeContainerScrollBar",
          ref: collegeContainerScrollBar
        }, [
          (_unref(collegeArray).length>0)
            ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(collegeArray), (item) => {
                    return (_openBlock(), _createBlock(_component_el_col, {
                      align: "center",
                      span: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          onClick: ($event: any) => (_unref(collegeNameClick)(item.collegeCode)),
                          class: "schoolCollegeItemLink"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.collegeName), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 256))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_el_empty, { description: "暂无数据" })
              ]))
        ], 512)
      ], 512), [
        [_vShow, _unref(elTabId) == '开设院校']
      ])
    ])
  ]))
}
}

})